export const environment = {
  production: false,
  cmsUrl: 'https://apicmstwo-devere-group-apps-com-d-2.dvep.net/api/',
  oldCmsUrl: 'https://apicms-devere-group-apps-com-d-2.dvep.net/api/', // For POST request only
  id: 40,
  masterId: 26,
  storageSettings: {
    websiteData: 'websiteData',
    websiteNews: 'websiteNews',
    websiteBlogs: 'websiteBlogs',
    websiteBanners: 'websiteBanners',
    websiteServices: 'websiteServices',
    genericFormCountriesNationalities: 'genericFormCountriesNationalities',
    websiteCompanies: 'websiteCompanies',
    websiteSeminars: 'websiteSeminars',
  },
};
